import { Summary } from '@shared/components/inventory_capture/summary';

export const PickupInventory = Summary;
